<template>
	<div class="form_toolbar" v-if="device=='pc'">
<!-- 		<template v-if="device!='pc'">
			<van-popover v-model="actionShow" trigger="click" :actions="item.children" @select="select"
				placement="bottom-start" v-for="(item,index) in mainItem" :key="index">
				<template #reference>
					<span class="el-dropdown-link">
						<span class="toolitem_text">{{item.title}}</span>
						<span class="step">|</span>
					</span>
				</template>
			</van-popover>
		</template> -->
		<template>
			<template v-for="(item,index) in mainItem">
				<el-dropdown size="small" @command="handleCommand" :key="index" v-if="item.children.length!=0">
					<span class="el-dropdown-link">
						<span class="toolitem_text">{{item.title}}</span>
						<span class="step">|</span>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item :command="_item.code" v-for="(_item,_index) in item.children"
							:disabled="_item.disabled" :key="_index">{{_item.title}}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</template>
		</template>
	</div>
</template>
<style scoped>
	.step {
		margin: 0 10px;
	}
</style>

<script>
	export default {
		props: {
			formToolbarConfig: {
				default: () => {
					return []
				}
			},
			mainForm: {
				default: () => {
					return null
				}
			},
			id: {
				type: [Number, String],
				default: () => {
					return 0
				}
			},
		},
		data() {
			return {
				mainItem: [{
					code: 'file',
					title: '文件',
					children: []
				},{
					code: 'tool',
					title: '工具',
					children: []
				}],
				actionShow: false,
				toolname: '',
				device: window.systemMethods.device()
			}
		},
		created() {
			this.formToolbarConfig.forEach((item) => {
				let currentItem = this.getItemByCode(item.group)
				if (currentItem) {
					item.text = item.title
					currentItem.children.push(item)
				}
			})
			console.log(this.mainItem)
		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			getItemByCode(code) {
				let findItem = null
				this.mainItem.forEach((item) => {
					if (item.code == code) {
						findItem = item
					}
				})
				return findItem
			},
			handleCommand(command) {
				this.$emit('buttonclick', command)
			},
			select(e) {
				this.handleCommand(e.code)
			},
			toolCommand(command) {
				this.toolname = command
			}
		},
		components: {

		}
	}
</script>
